/**
 * AnnouncementLinkTypeService
 * Service for managing announcement link types
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement link type CRUD operations
 */
export class AnnouncementLinkTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementLinkTypeService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementLinkTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AnnouncementLinkTypeService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementLinkTypeService.BASE_PATH = 'api/announcement-link-types';
//# sourceMappingURL=AnnouncementLinkTypeService.js.map